//React
import React from 'react';

//Resource

//interfaces

//pages
import { ReportManagement } from 'pages/reports';
import { useAdminReportManagementData } from './useAdminReportManagementData';

export const AdminReportManagement: React.FC = () => {
  const {
    reports,
    sites,
    providers,
    submissions,
    payors,
    isLoading,
    isError,
    isFetching,
    errorMessage,
    remittances,
    refetchReports,
  } = useAdminReportManagementData();

  return (
    <ReportManagement
      reports={reports}
      remittances={remittances}
      sites={sites}
      providers={providers}
      submissions={submissions}
      payors={payors}
      isError={isError}
      isLoading={isLoading}
      isFetching={isFetching}
      refetchReports={refetchReports}
      errorMessage={errorMessage}
    />
  );
};
